import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  alert: () => __(translations.reincarnation.alert, 'Alert!'),
  cancel: () => __(translations.reincarnation.cancel, 'Cancel'),
  restoreConfirmation: () => __(translations.reincarnation.restoreConfirmation, 'Do you really wish to bring this resource back?'),
  yesImSure: () => __(translations.reincarnation.yesImSure, "Yes, I'm sure"),
};
